import React from "react";
import Navbar from "../../../Components/Navbar/Navbar";

const Testimonials = () => {
  return (
    <div>
      <Navbar label="Sign In" />
      <h1>This is testimonials page</h1>
    </div>
  );
};

export default Testimonials;
